export function validateOfacFiles(files) {
  const selected = Array.from(files || []);
  if (selected.some(file => !file.size || file.size > 50_000_000)) throw new Error('The OFAC file must be between 1 byte and 50 MB.');
  if (selected.length !== 1 || !/\.xml$/i.test(selected[0].name)) {
    throw new Error('Select one complete SDN.XML file.');
  }
  return selected;
}
export async function importOfacFiles({ files, user, apiBase, fetchImpl = fetch }) {
  const selected = validateOfacFiles(files);
  if (!user) throw new Error('Sign in to import a source.');
  const token = await user.getIdToken();
  const encoded = await Promise.all(selected.map(file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve({ name: file.name, base64: String(reader.result).split(',')[1] });
    reader.onerror = () => reject(new Error('Could not read the selected source file.'));
    reader.readAsDataURL(file);
  })));
  const response = await fetchImpl(`${apiBase.replace(/\/$/, '')}/myKyc/admin/sanctions-sources/ofac/import`, {
    method: 'POST', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }, body: JSON.stringify({ files: encoded }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || !data.ok) throw new Error(data.error || 'OFAC import failed. The previous source was retained.');
}
